import { useMutation, useQueryClient } from '@tanstack/react-query';

import { withError } from '@/react-tools/react-query';
import { AlertRuleAttachmentsPayload } from '@/react/portainer/observability/types';
import axios from '@/react/portainer/services/axios/axios';
import { parseAxiosError } from '@/react/portainer/services/axios/utils/parseAxiosError';

import { queryKeys } from '../../queryKeys';

export function useUpdateAlertRuleAttachments(id: number) {
  const queryClient = useQueryClient();

  return useMutation(updateAlertRuleAttachments(id), {
    ...withError('Unable to update alert rule attachments'),
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.attachments(id));
    },
  });
}

function updateAlertRuleAttachments(id: number) {
  return async function mutate(attachments: AlertRuleAttachmentsPayload) {
    try {
      const { data } = await axios.put<AlertRuleAttachmentsPayload>(
        `/observability/alerting/rules/${id}/groups`,
        attachments
      );
      return data;
    } catch (error) {
      throw parseAxiosError(error);
    }
  };
}
